import { render, staticRenderFns } from "./BioNERView.vue?vue&type=template&id=188225be&scoped=true&"
import script from "./BioNERView.vue?vue&type=script&lang=js&"
export * from "./BioNERView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188225be",
  null
  
)

export default component.exports